document.documentElement.classList.add('js');


/* ==========================================================================
   BeadPops — home page

   UN SEUL VOCABULAIRE DE MOUVEMENT, partout :
   · data-mot      le titre se révèle mot par mot (flou 10px + montée .42em)
   · data-monte    le bloc monte de 18px et se défloute
   · data-image    le visuel se dévoile par le bas et se pose (scale 1.05 → 1)
   · data-cascade  les enfants s'enchaînent, décalage constant

   Le geste vient de 21st.dev @cnippet.dev/text-reveal (révélation par
   segments : opacité + flou + y, décalage régulier), transposé en GSAP.
   Le carrousel vient de @animbits/linear-carousel (piste dupliquée, boucle
   sans couture, défilement continu, glisser, pause au survol).

   Un seul moment est piloté au scroll : la démonstration en trois étapes.
   ========================================================================== */

document.documentElement.classList.add('js');
gsap.registerPlugin(ScrollTrigger);

var DUREE  = 0.62;
var DECAL  = 0.055;
var SORTIE = 'power3.out';

/* ==========================================================================
   1. LE SYSTÈME DE RÉVÉLATION
   ========================================================================== */
(function reveler(){

  // Un <br> dans le titre est gardé : le découpage mot par mot le perdait, et
  // « Le scroll, c'est fini. Place au pixel art. » coupait alors au milieu
  // d'une phrase. `null` marque le retour à la ligne.
  document.querySelectorAll('[data-mot]').forEach(function(el){
    var mots = [];
    el.childNodes.forEach(function(n){
      if (n.nodeName === 'BR') { mots.push(null); return; }
      n.textContent.trim().split(/\s+/).forEach(function(m){ if (m) { mots.push(m); } });
    });
    el.textContent = '';
    mots.forEach(function(m, i){
      if (m === null) { el.appendChild(document.createElement('br')); return; }
      var boite = document.createElement('span');
      boite.className = 'mot';
      var inner = document.createElement('span');
      inner.textContent = m;
      boite.appendChild(inner);
      el.appendChild(boite);
      if (mots[i + 1]) { el.appendChild(document.createTextNode(' ')); }
    });
  });

  // « -2.8,2.5 » → [-2.8, 2.5], appliqués enfant par enfant, en boucle.
  // `data-pench-lg` ne vaut que sur grand écran : certaines inclinaisons
  // n'ont de sens qu'avec les cartes côte à côte.
  function angles(el){
    var v = el.getAttribute('data-pench');
    if (!v && window.innerWidth > 900) { v = el.getAttribute('data-pench-lg'); }
    return v ? v.split(',').map(parseFloat) : [];
  }

  function joue(el){
    if (el.dataset.vu) { return; }
    el.dataset.vu = '1';

    if (el.hasAttribute('data-mot')) {
      gsap.to(el.querySelectorAll('.mot > span'), {
        opacity: 1, filter: 'blur(0px)', y: 0,
        duration: DUREE, ease: SORTIE, stagger: DECAL
      });
    } else if (el.hasAttribute('data-monte')) {
      gsap.to(el, { opacity: 1, filter: 'blur(0px)', y: 0, duration: DUREE, ease: SORTIE });
    } else if (el.hasAttribute('data-image')) {
      gsap.to(el.children, {
        clipPath: 'inset(0% 0% 0% 0%)', scale: 1, rotation: angles(el)[0] || 0,
        duration: DUREE * 1.5, ease: SORTIE,
        // Le clip-path doit disparaitre une fois le devoilement fini, sinon il
        // continue de rogner : ombres coupees net et coins inclines tranches,
        // ce qui donne l impression d une boite posee autour du visuel.
        onComplete: function(){
          for (var i = 0; i < el.children.length; i++) { el.children[i].style.clipPath = 'none'; }
        }
      });
    } else if (el.hasAttribute('data-cascade')) {
      var pench = angles(el);
      gsap.to(el.children, {
        opacity: 1, y: 0,
        // L'inclinaison est portée par GSAP et non par le CSS : dès qu'il
        // anime un élément, il écrit `rotate: none` en ligne pour garder la
        // main sur les transformations, et la règle de la feuille saute.
        rotation: pench.length ? function(i){ return pench[i % pench.length]; } : 0,
        duration: DUREE, ease: SORTIE, stagger: DECAL * 1.6
      });
    }
  }

  var observe = new IntersectionObserver(function(entrees){
    entrees.forEach(function(e){
      if (e.isIntersecting) { joue(e.target); observe.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

  document.querySelectorAll('[data-mot],[data-monte],[data-image],[data-cascade]')
    .forEach(function(el){ observe.observe(el); });
})();

/* ==========================================================================
   2. LA DÉMONSTRATION — l'animation image par image du site
   Deux planches réelles : 29 vues de la pose (grille 6 × 5, la dernière
   case est vide) puis 8 vues du résultat (grille 4 × 2). Le scroll avance
   dans la séquence, exactement comme sur la home actuelle. Rien n'est simulé.
   ========================================================================== */
(function demonstration(){
  var piste  = document.querySelector('[data-demo-piste]');
  var video  = document.querySelector('[data-pose]');
  var etat   = document.querySelector('[data-pose-etat]');
  var fiches = document.querySelectorAll('.fiche');
  var fil    = document.querySelector('[data-fil]');
  if (!piste || !video) { return; }

  // Le fil « marche » en continu, comme dans le composant d'origine
  // (21st.dev @chamaac/how-it-works).
  if (fil) { gsap.to(fil, { strokeDashoffset: -160, duration: 3.2, repeat: -1, ease: 'none' }); }

  video.addEventListener('loadedmetadata', function(){ ScrollTrigger.refresh(); });

  // LA VIDÉO TOURNE TOUTE SEULE, elle ne se déroule plus sous le doigt.
  // Décision de l'opérateur, 2026-09-17 : la vraie prise de vue se regarde, elle ne
  // se fait pas piloter. Au premier clic, les commandes natives apparaissent et la
  // personne reprend la main (avancer, reculer, mettre en pause).
  video.addEventListener('click', function(){
    if (!video.controls) { video.controls = true; }
  });
  // La légende suit la vidéo, plus le scroll : sinon elle annonce une étape que
  // l'image ne montre pas.
  if (etat) {
    video.addEventListener('timeupdate', function(){
      var duree = video.duration;
      if (!duree || !isFinite(duree)) { return; }
      var p = video.currentTime / duree;
      etat.textContent = p < 0.12 ? 'On commence'
                       : p < 0.55 ? 'Une couleur, puis la suivante'
                       : p < 0.86 ? 'Le pixel art apparaît'
                       : 'Terminé';
    });
  }

  function rendre(p){
    // les fiches se posent une par une, la première dès l'entrée
    var n = Math.min(fiches.length, Math.floor(p * fiches.length) + 1);
    fiches.forEach(function(f, i){
      f.classList.toggle('est-posee', i < n);
      f.classList.toggle('est-active', i === n - 1);
    });
  }

  rendre(0);

  // Sur mobile la scène n'est plus figée par la piste : c'est la vidéo qui
  // se colle en haut (CSS sticky) pendant que les fiches défilent dessous.
  // On pilote donc le défilement sur la grille, pas sur la piste.
  var petit = window.matchMedia('(max-width: 900px)').matches;
  // Sur mobile on suit la colonne des fiches, pas la grille : la grille est à
  // peine plus haute que l'écran, la plage de défilement se serait résumée à
  // deux cents pixels et le compteur repartait à zéro.
  ScrollTrigger.create({
    trigger: petit ? document.querySelector('.chemin') : piste,
    start: petit ? 'top 86%' : 'top top',
    end:   petit ? 'bottom 55%' : 'bottom bottom',
    onUpdate: function(self){ rendre(Math.min(1, self.progress * 1.04)); }
  });
})();

/* ==========================================================================
   3. LE SÉLECTEUR DU KIT
   ========================================================================== */
(function selecteur(){
  var liste = document.querySelector('[data-kit-liste]');
  var titre = document.querySelector('[data-kit-titre]');
  var texte = document.querySelector('[data-kit-texte]');
  if (!liste) { return; }

  var FICHES = [
    ['Stylo multi-perles',
     "Pour poser plusieurs perles d'une même couleur d'un seul geste, au lieu d'une par une."],
    ['Pince de précision',
     "Pour attraper et placer les perles là où il est difficile de les manipuler."],
    ['Plateaux à perles',
     "Pour aligner et présenter tes perles, prêtes à être attrapées au stylo ou à la pince."],
    ['Plaques de création',
     "Le support à picots sur lequel tu poses tes perles pour composer ton pixel art. Des plaques qui s'emboîtent pour agrandir ta zone quand ton motif est grand."],
    ['Tes perles',
     "Les perles nécessaires à tes modèles, triées par couleur. C'est le cœur de ta création."],
    ['Ruban adhésif',
     "Pour décoller ton pixel art de la plaque d'un seul geste, sans qu'aucune perle ne bouge."],
    ['Feuille de repassage',
     "Une fois tes perles décollées, le ruban reste dessous pour les maintenir. Tu poses la feuille sur la face du dessus, celle sans ruban, et tu repasses par-dessus."]
  ];

  /* LA PIÈCE SUR LA PHOTO, en % de l'image : [gauche, haut, largeur, hauteur].
     Relevées sur kit-contenu.webp (1448×1086, photo de l'opérateur du 2026-10-05). Si la photo change, les relever
     de nouveau. Les sept pièces y figurent toutes.
     La photo reste nette au chargement : on voit d'abord le coffret, la zone
     n'apparaît qu'au premier choix. */
  var zone = document.querySelector('[data-kit-zone]');
  var ZONES = [
    [4.5, 65.0, 27.0, 26.0],
    [61.5, 71.5, 21.5, 22.5],
    [33.5, 70.5, 27.0, 22.0],
    [0.3, 13.0, 32.0, 47.0],
    [23.8, 42.5, 54.5, 32.5],
    [80.5, 63.0, 16.2, 24.5],
    [67.3, 11.5, 32.2, 42.0]
  ];
  var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var visible = false;
  function eclaire(i){
    if (!zone) { return; }
    var z = ZONES[i];
    if (!z) {
      gsap.to(zone, { opacity: 0, duration: calme ? 0 : 0.3, ease: 'power2.out' });
      visible = false;
      return;
    }
    var cible = { left: z[0] + '%', top: z[1] + '%', width: z[2] + '%', height: z[3] + '%' };
    if (!visible || calme) {
      gsap.set(zone, cible);
      gsap.to(zone, { opacity: 1, duration: calme ? 0 : 0.35, ease: 'power2.out' });
    } else {
      gsap.to(zone, Object.assign({ duration: 0.5, ease: SORTIE }, cible));
    }
    visible = true;
  }

  liste.addEventListener('click', function(e){
    var b = e.target.closest('[data-kit]');
    if (!b) { return; }
    var f = FICHES[+b.dataset.kit];
    liste.querySelectorAll('button').forEach(function(x){
      x.classList.toggle('est-actif', x === b);
      x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
    });
    eclaire(+b.dataset.kit);
    gsap.to([titre, texte], {
      opacity: 0, y: 6, duration: 0.16, ease: 'power2.in',
      onComplete: function(){
        titre.textContent = f[0];
        texte.textContent = f[1];
        gsap.to([titre, texte], { opacity: 1, y: 0, duration: 0.3, ease: SORTIE, stagger: 0.04 });
      }
    });
  });
})();

/* ==========================================================================
   3 bis. LA RANGÉE DES UNIVERS
   Le défilement est natif (doigt, pavé, molette horizontale) ; les flèches
   servent à la souris. Elles avancent d'une tuile et s'éteignent au bout.
   Si les six tuiles tiennent à l'écran, elles disparaissent.
   ========================================================================== */
(function rangeeUnivers(){
  var piste = document.querySelector('[data-piste]');
  var prec = document.querySelector('[data-piste-prec]');
  var suiv = document.querySelector('[data-piste-suiv]');
  if (!piste || !prec || !suiv) { return; }
  var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pas(){
    var li = piste.children;
    if (li.length < 2) { return piste.clientWidth; }
    return li[1].getBoundingClientRect().left - li[0].getBoundingClientRect().left;
  }
  function etat(){
    var reste = piste.scrollWidth - piste.clientWidth;
    prec.parentNode.hidden = reste < 2;
    prec.disabled = piste.scrollLeft < 2;
    suiv.disabled = piste.scrollLeft > reste - 2;
  }
  prec.addEventListener('click', function(){
    piste.scrollBy({ left: -pas(), behavior: calme ? 'auto' : 'smooth' });
  });
  suiv.addEventListener('click', function(){
    piste.scrollBy({ left: pas(), behavior: calme ? 'auto' : 'smooth' });
  });
  piste.addEventListener('scroll', etat, { passive: true });
  window.addEventListener('resize', etat);
  etat();
})();

/* ==========================================================================
   4. LE CARROUSEL D'INSPIRATION
   ========================================================================== */
(function carrousel(){
  var cadre = document.querySelector('[data-carrousel]');
  var piste = document.querySelector('[data-carrousel-piste]');
  if (!cadre || !piste) { return; }

  var origine = Array.prototype.slice.call(piste.children);
  origine.forEach(function(n){ piste.appendChild(n.cloneNode(true)); });

  var x = 0, largeur = 0, vitesse = 0.42, pause = false;
  var tire = false, departX = 0, departOffset = 0, bouge = 0;
  // 2026-10-11 (passe UX) : « réduire les animations » arrête le défilement continu.
  // Les flèches et le glisser restent : la personne avance quand elle le veut.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { vitesse = 0; }

  function mesure(){
    var gap = parseFloat(getComputedStyle(piste).gap) || 0;
    largeur = origine.reduce(function(t, n){ return t + n.offsetWidth + gap; }, 0);
  }
  function poseX(){
    if (largeur > 0) {
      if (x <= -largeur) { x += largeur; }
      if (x > 0) { x -= largeur; }
    }
    piste.style.transform = 'translate3d(' + x + 'px,0,0)';
  }
  function boucle(){
    if (!pause && !tire) { x -= vitesse; poseX(); }
    requestAnimationFrame(boucle);
  }

  cadre.addEventListener('mouseenter', function(){ pause = true; });
  cadre.addEventListener('mouseleave', function(){ pause = false; });

  cadre.addEventListener('pointerdown', function(e){
    tire = true; bouge = 0; departX = e.clientX; departOffset = x;
    cadre.classList.add('est-tire');
    cadre.setPointerCapture(e.pointerId);
  });
  cadre.addEventListener('pointermove', function(e){
    if (!tire) { return; }
    var d = e.clientX - departX;
    bouge = Math.max(bouge, Math.abs(d));
    x = departOffset + d;
    poseX();
  });
  ['pointerup', 'pointercancel'].forEach(function(t){
    cadre.addEventListener(t, function(){ tire = false; cadre.classList.remove('est-tire'); });
  });
  // un glisser ne doit pas déclencher le lien de la carte
  cadre.addEventListener('click', function(e){ if (bouge > 8) { e.preventDefault(); } }, true);

  document.querySelectorAll('[data-cr]').forEach(function(b){
    b.addEventListener('click', function(){
      var gap = parseFloat(getComputedStyle(piste).gap) || 0;
      var pas = origine[0].offsetWidth + gap;
      gsap.to({ v: x }, {
        v: x - pas * (+b.dataset.cr), duration: 0.55, ease: SORTIE,
        onUpdate: function(){ x = this.targets()[0].v; poseX(); }
      });
    });
  });

  window.addEventListener('resize', mesure);
  window.addEventListener('load', function(){ mesure(); poseX(); });
  mesure(); poseX(); boucle();
})();

/* ==========================================================================
   5. LA BARRE D'ACHAT — le point d'entrée permanent
   ========================================================================== */
(function barre(){
  var barre = document.querySelector('[data-barre]');
  var hero  = document.getElementById('hero');
  var pied  = document.querySelector('.pied');
  if (!barre) { return; }

  // 2026-10-11 (passe UX) : la barre se retire tant qu'un bouton du Starter Kit est
  // deja a l'ecran (fin de la demonstration, achat du kit, comparatif). Elle doublait
  // le prix et le bouton juste au-dessus d'elle (deux « 44,99 € » et deux boutons
  // orange sur le meme ecran, au telephone dans le kit) et recouvrait le bas de la
  // scene epinglee. Une seule action visible a la fois : quand le bouton de la page
  // sort de l'ecran, la barre revient.
  var doublons = Array.prototype.slice.call(
    document.querySelectorAll('.demo-cta .cta, .kit-achat, .comparatif .centre-bloc .cta'));
  function aLecran(el){
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function ajuste(){
    var passe = hero ? hero.getBoundingClientRect().bottom < 40 : true;
    var loin  = pied ? pied.getBoundingClientRect().top > window.innerHeight - 40 : true;
    var seule = !doublons.some(aLecran);
    var montre = passe && loin && seule;
    barre.classList.toggle('est-visible', montre);
    // Hors de l'ecran, ses liens ne se prennent plus au clavier (2026-10-11).
    barre.inert = !montre;
  }
  var attente = false;
  window.addEventListener('scroll', function(){
    if (attente) { return; }
    attente = true;
    requestAnimationFrame(function(){ ajuste(); attente = false; });
  }, { passive: true });
  window.addEventListener('resize', ajuste);
  ajuste();
})();

/* ==========================================================================
   5 bis. LES VIDÉOS HORS ÉCRAN SE METTENT EN PAUSE (2026-10-11, passe UX)
   Sept vidéos tournaient en boucle en même temps, la plupart hors de l'écran :
   le téléphone décodait pour rien et vidait sa batterie. Chacune joue quand
   elle entre à l'écran et s'arrête quand elle en sort. Une vidéo dont la
   personne a pris les commandes (la démonstration, au clic) n'est plus
   relancée d'office : c'est elle qui décide.
   ========================================================================== */
(function videosHorsEcran(){
  var videos = document.querySelectorAll('section video[autoplay]');
  // « Réduire les animations » : aucune vidéo ne part seule. Chacune s'arrête sur
  // sa première image et montre ses commandes ; on la lance si on veut la voir.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    videos.forEach(function(v){ v.removeAttribute('autoplay'); v.pause(); v.controls = true; });
    return;
  }
  if (!('IntersectionObserver' in window)) { return; }
  var obs = new IntersectionObserver(function(entrees){
    entrees.forEach(function(e){
      var v = e.target;
      if (e.isIntersecting) {
        if (v.controls) { return; }
        var p = v.play();
        if (p && p.catch) { p.catch(function(){}); }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '120px 0px' });
  videos.forEach(function(v){ obs.observe(v); });
})();








/* Allègement : la pastille touchée se recentre dans la rangée */document.addEventListener('click',function(e){var b=e.target.closest('[data-kit-liste] button');if(b&&matchMedia('(max-width:749px)').matches){b.scrollIntoView({inline:'center',block:'nearest',behavior:'smooth'})}});
